export enum LeadTaskStatus {
  NotDefined = 0, // For tab Inbox
  Planned = 1, // For tab For Review (Til vurdering)
  WorkingOn = 2, // For tab For Review (Til vurdering)
  Waiting = 3, // For tab For Review (Til vurdering)
  Archived = 4, // For tab Archive
  ProposalCreated = 5, // Will not be visible in any of the list views
}
